import React from 'react'
import ChartProgressBar from '../../../../../../Portfolio_R/SummaryCharts/components/ChartProgressBar'

const ProjectionsYearLon = ({ t, data, mp }) => {
    return (
        <div className="disbursement">
            <h3 className="chart-title">{t('one_pager_report.year_disbursements')}</h3>
            <div className="chart-content">
                <ChartProgressBar
                    completed={data.projectionsDisbursementsYearPercent}
                    totalAmount={mp.yearDisbTotal}
                    disbursmentAmount={data.projectionsDisbursementsYearAmount}
                    format='USD'
                />
            </div>
        </div>
    )
}

export default ProjectionsYearLon